import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ThemeProvider } from "./contexts/ThemeContext";
import { IntlProvider } from "./contexts/IntlContext";
import { BrandProvider } from "./contexts/BrandContext";
import { VocabularyProvider } from "./contexts/VocabularyContext";
import { QueryClientProvider } from "./contexts/QueryClientProvider";
import { AuthProvider } from "./contexts/AuthContext";
import { OrgProvider } from "./contexts/OrgContext";
import { OrgScopedQueryBoundary } from "./contexts/OrgScopedQueryBoundary";
import "./styles/index.css";

// Provider order, outer → inner:
//   ThemeProvider     — applies CSS-var tokens to :root (no React state dep)
//   IntlProvider      — formatters; depends on nothing
//   BrandProvider     — hostname-overlay-aware; depends on nothing in CHG-1167
//   VocabularyProvider — vocabulary lookup; depends on Brand for variant overlay
//   QueryClientProvider — react-query; sits above auth so token-refresh queries work
//   AuthProvider      — auth state; depends on QueryClient for /me bootstrap
//   OrgProvider       — active org; depends on Auth for memberships list
//   OrgScopedQueryBoundary — tenant-safe page cache; depends on Auth + Org
//
// Per CHG-1167 every provider is a STUB — wiring lands in later α/β CHGs.

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <IntlProvider>
        <BrandProvider>
          <VocabularyProvider>
            <QueryClientProvider>
              <AuthProvider>
                <OrgProvider>
                  <OrgScopedQueryBoundary>
                    <BrowserRouter>
                      <App />
                    </BrowserRouter>
                  </OrgScopedQueryBoundary>
                </OrgProvider>
              </AuthProvider>
            </QueryClientProvider>
          </VocabularyProvider>
        </BrandProvider>
      </IntlProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
